const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmail(email) {
  return typeof email === 'string' ? email.trim().toLowerCase() : '';
}

export function isValidEmail(email) {
  const value = normalizeEmail(email);
  return value.length > 0 && EMAIL_REGEX.test(value);
}

export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Customer-facing Teams member/licence labels.
 * Internal values remain team_basic / team_pro.
 * @param {string|null|undefined} tier
 * @param {{ short?: boolean }} [options] short=true yields "Basic"/"Pro" when context is clear
 */
export function seatLabel(tier, { short = false } = {}) {
  if (!tier) return 'Unassigned';
  if (tier === 'team_pro') return short ? 'Pro' : 'Teams Pro';
  if (tier === 'team_basic') return short ? 'Basic' : 'Teams Basic';
  return short ? 'Basic' : 'Teams Basic';
}

export const licenceLabel = seatLabel;

export function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) return '?';
  return parts.map((part) => part[0].toUpperCase()).join('');
}

export function parseEmailsFromPaste(text) {
  return String(text || '')
    .split(/[\s,;]+/)
    .map((item) => normalizeEmail(item))
    .filter(Boolean);
}

export function pageTitleFromPath(pathname, fallback = 'Company') {
  const parts = String(pathname || '').split('/').filter(Boolean);
  const section = parts[2];
  if (section === 'dashboard') return 'Overview';
  if (section === 'teams') return parts[3] ? 'Team' : 'Teams';
  if (section === 'members') return 'Account';
  if (section === 'seats') return 'Seats';
  if (section === 'branding') return 'Branding';
  if (section === 'contacts') return 'Company contacts';
  if (section === 'invites') return 'Invitations';
  if (section === 'analytics') return 'Analytics';
  if (section === 'orders') return 'Orders';
  return fallback;
}

export function usagePercent(used, total) {
  const safeUsed = Number(used) || 0;
  const safeTotal = Number(total) || 0;
  if (safeTotal <= 0) return 0;
  return Math.min(100, Math.round((safeUsed / safeTotal) * 100));
}
